import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from '@/presentation/hooks/useTranslation';
import { Ghost } from '@pelando/fontawesome/icons';
import { EmptyProfileState } from './style';
import { EmptyIcon } from '../../styles';

function EmptyProfilePage() {
  const { t } = useTranslation('profile');
  const { push } = useRouter();

  return (
    <EmptyProfileState
      title={t('empty-profile-page-title')}
      buttonTitle={t('empty-profile-page-button')}
      content={<>{t('empty-profile-page-content')}</>}
      onClick={() => push('/')}
      icon={<EmptyIcon icon={Ghost} />}
    />
  );
}

export default EmptyProfilePage;
